import React from 'react';
import EventImage from '../../../../components/EventImage';
import { fixS3ImageUrl } from '../../../../components/imageUtils';

const getBackgroundStyle = (rawBackground) => {
  if (!rawBackground) {
    return {};
  }

  let background = rawBackground;

  // Allow background to be either a real array, JSON-stringified array,
  // or a Postgres text[] string like {image,"https://..."}
  if (!Array.isArray(background) && typeof background === 'string') {
    const trimmed = background.trim();

    // First, try JSON.parse (e.g. '["image","https://..."]')
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) {
        background = parsed;
      }
    } catch {
      // If it's not JSON, handle Postgres array syntax
      if (trimmed.startsWith('{') && trimmed.endsWith('}')) {
        const inner = trimmed.slice(1, -1);
        const parts = inner.split(',');
        if (parts.length > 0) {
          background = parts.map((p) => {
            const t = p.trim();
            if ((t.startsWith('"') && t.endsWith('"')) || (t.startsWith("'") && t.endsWith("'"))) {
              return t.slice(1, -1);
            }
            return t;
          });
        }
      }
    }
  }

  if (!Array.isArray(background) || background.length === 0) {
    return {};
  }

  const mode = background[0];
  const value1 = background[1];
  const value2 = background[2];

  if (mode === 'solid' && value1) {
    return {
      backgroundColor: value1,
      backgroundImage: 'none',
    };
  }

  if (mode === 'gradient' && value1 && value2) {
    return {
      backgroundImage: `linear-gradient(90deg, ${value1}, ${value2})`,
      backgroundColor: 'transparent',
    };
  }

  if (mode === 'image' && value1) {
    const fixedBgUrl = fixS3ImageUrl(value1);
    return {
      backgroundImage: `url(${fixedBgUrl})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundColor: 'transparent',
    };
  }

  return {};
};

const ImageCard = ({ event }) => {
  if (!event) return null;

  const coverImage = event.image || event.bannerimage || event.file_url || '/fallback-logo.png';
  const backgroundArray = event.background || event.background_images_array || null;

  return (
    <div
      className="event-details-card__image-container"
      style={getBackgroundStyle(backgroundArray)}
    >
      <EventImage
        image={event.file_url}
        coverimage={coverImage}
        alt={event.name}
        className="event-details-card__image"
        loading="eager"
      />
    </div>
  );
};

export default ImageCard;
